import { TextField } from '@mui/material';
import { Base } from '../Base';

// Input.TextArea
export const TextArea = (props) => (
  <Base {...props} isTextArea Input={TextField} />
);
